import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "proportion-selector" }
const _hoisted_2 = { class: "grid gap-x-2 grid-cols-3 items-start" }
const _hoisted_3 = { class: "sign-checkboxs" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

import CSign from '@/components/svg/CSign.vue';
import CSlashSign from '@/components/svg/CSlashSign.vue';
import RezTabFile from '@/store/modules/RezTabFile';
import { ref, watch } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProportionSelector',
  setup(__props) {

const store = useStore();
function getDoc() { return store.state.currentDoc as RezTabFile; }
const isCSign = ref(getDoc().docSettings.proportion.sign == 'C' && !getDoc().docSettings.proportion.slash);
const isCSlashSign = ref(getDoc().docSettings.proportion.slash == 1);
const showSign = ref(!!getDoc().docSettings.proportion.sign);
const getNum = () => getDoc().docSettings.proportion.num;
const setNum = (n: number) => getDoc().docSettings.proportion.num = n
const getNumbase = () => getDoc().docSettings.proportion.numbase;
const setNumbase = (n: number) => getDoc().docSettings.proportion.numbase = n
const num = ref(getNum())
const numbase = ref(getNumbase())
watch(num, (val) => {
    setNum(val);
    updateSignSituation()

});
watch(numbase, (val) => {
    setNumbase(val);
    updateSignSituation()

})
watch(isCSign, val => {
    if (val == true) {
        showSign.value = true;
        getDoc().docSettings.proportion.sign = "C"
        delete getDoc().docSettings.proportion.slash
        isCSlashSign.value = false;

        num.value = 4;
        numbase.value = 4
    }
})
watch(isCSlashSign, val => {
    if (val == true) {
        showSign.value = true;
        isCSign.value = false;
        getDoc().docSettings.proportion.sign = "C"
        getDoc().docSettings.proportion.slash = 1
        num.value = 2;
        numbase.value = 2
    }
})
watch(showSign, val => {
    if (val == false) {
        delete getDoc().docSettings.proportion.sign
        delete getDoc().docSettings.proportion.slash
    }
})

/**on Num And Numbase Updated */
function updateSignSituation() {
    if (!(num.value == 2 && numbase.value == 2)) isCSlashSign.value = false
    if (!(num.value == 4 && numbase.value == 4)) isCSign.value = false
    if (!isCSign.value && !isCSlashSign.value) showSign.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_va_input = _resolveComponent("va-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_va_checkbox, {
        label: "Fixed Measures",
        modelValue: getDoc().docSettings.fixedMeasures,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((getDoc().docSettings.fixedMeasures) = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (getDoc().docSettings.proportion.include = true))
        ]
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_va_checkbox, {
      modelValue: getDoc().docSettings.proportion.include,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((getDoc().docSettings.proportion.include) = $event)),
      class: _normalizeClass({ 'enabled': getDoc().docSettings.proportion.include }),
      label: "Include Proportion"
    }, null, 8, ["modelValue", "class"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_va_input, {
        disabled: !getDoc().docSettings.proportion.include,
        color: "white",
        type: "number",
        label: "num",
        modelValue: num.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((num).value = $event))
      }, null, 8, ["disabled", "modelValue"]),
      _createVNode(_component_va_input, {
        disabled: !getDoc().docSettings.proportion.include,
        color: "white",
        type: "number",
        label: "numbase",
        modelValue: numbase.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((numbase).value = $event))
      }, null, 8, ["disabled", "modelValue"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_va_checkbox, {
          label: "show sign",
          modelValue: showSign.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showSign).value = $event)),
          disabled: !getDoc().docSettings.proportion.include || !(
                        (num.value == 2 && numbase.value == 2) || (num.value == 4 && numbase.value == 4)
                    )
        }, null, 8, ["modelValue", "disabled"]),
        _createElementVNode("label", {
          for: "c-sign-input",
          class: _normalizeClass({ 'opacity-55': !(showSign.value && isCSign.value) })
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "c-sign-input",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isCSign).value = $event)),
            disabled: !getDoc().docSettings.proportion.include
          }, null, 8, _hoisted_4), [
            [_vModelCheckbox, isCSign.value]
          ]),
          _createVNode(CSign)
        ], 2),
        _createElementVNode("label", {
          for: "c-slash-sign-input",
          class: _normalizeClass({ 'opacity-55': !(showSign.value && isCSlashSign.value) })
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "c-slash-sign-input",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isCSlashSign).value = $event)),
            disabled: !getDoc().docSettings.proportion.include
          }, null, 8, _hoisted_5), [
            [_vModelCheckbox, isCSlashSign.value]
          ]),
          _createVNode(CSlashSign)
        ], 2)
      ])
    ])
  ]))
}
}

})